import React from "react";
/// React router dom
import { Routes, Route, Outlet } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";

/// Dashboard
import Home from "./components/Dashboard/Home";

import Task from "./components/Dashboard/Task";

import ScrollToTop from "./layouts/ScrollToTop";
import UserList from "./pages/UserList";
import AppConfig from "./pages/AppConfig/AppConfig";
import CategoryConfig from "./pages/AppConfig/CategoryConfig";
import JobPosting from "./pages/JobPosting";
import ServicePosting from "./pages/ServicePosting";
import JobDetails from "./pages/JobDetails";
import Price from "./pages/Price";
import Flag from "./pages/Flag";
import UserDetails from "./pages/UserDetails";
import SubEvents from "./pages/SubEvents";
import TaskPage from "./pages/Tasks";
import EditPartner from "./Modals/EditPartner";
import Co_host_Detail from "./pages/Co_host_Detail";
import EventDetails from "./pages/EventDetails";
import Guest from "./pages/Guest";
import UserEvents from "./pages/UserEvents";
import Co_Hosts from "./pages/Co_Hosts";
import UnEnroll from "./pages/UnEnroll";
import Notification from "./pages/Notification";
import NewUsers from "./pages/NewUsers";
import FAQS from "./pages/FAQS";
import Template from "./pages/Template";
import SubEvent from "./pages/SubEvent";
import Taskss from "./pages/Task";
import GuestList from "./pages/GuestList";
import { Subscript } from "lucide-react";
import Subscriptions from "./pages/Subscriptions";
import USER_GUESTS from "./pages/User_Guests";
import Event_tasks from "./pages/Event_tasks";
import EventListingGuest from "./pages/EventListingGuest";
import EventListingSubEvents from "./pages/EventListingSubEvents";
import AboutUs from "./pages/AboutUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundAndCancellationPolicy from "./pages/RefundAndCancellationPolicy";
import Photo_Gallery from "./pages/Photo_Gallery";
import OtpLogin from "./pages/OTP";
import USER_PHOTO from "./pages/USER_PHOTO";
import Package from "./pages/Package";
import Partners from "./pages/Partners";
import PartnerDetail from "./pages/PartnerDetail";
import CreatePartner from "./pages/CreatePartner";
import PartnerEvents from "./pages/PartnerEvents";
import DeletePage from "./pages/DeletePage";
import PlanWeddings from "./pages/PlanWeddings";

const Markup = () => {
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  const allroutes = [
    /// Dashboard
    { url: "", component: <Home /> },
    { url: "dashboard", component: <Home /> },
    { url: "category", component: <AppConfig /> },
    { url: "category-config", component: <CategoryConfig /> },
    { url: "task", component: <Task /> },
    { url: "user-management", component: <UserList /> },
    { url: "events", component: <JobPosting /> },
    { url: "service-posting", component: <ServicePosting /> },
    { url: "job-details", component: <JobDetails /> },
    { url: "price", component: <Price /> },
    { url: "report", component: <Flag /> },
    { url: "user-details", component: <UserDetails /> },
    { url: "user-details/:id", component: <UserDetails /> },
     { url: "host-wedding/:id", component: <UserDetails /> },
    { url: "sub-events/:id1/:id2", component: <SubEvents /> },
    { url: "tasks/:id1/:id2", component: <TaskPage /> },
    { url: "co-host/:id", component: <Co_host_Detail /> },
    { url: "event_details/:id", component: <EventDetails /> },
    { url: "event_details/:id/guests", component: <EventListingGuest /> },
    {
      url: "event_details/:id/sub-events",
      component: <EventListingSubEvents />,
    },
    { url: "guests/:id1/:id2", component: <Guest /> },
    { url: "user_events/:id", component: <UserEvents /> },

    { url: "/user-details/:id/co-hosts-list", component: <Co_Hosts /> },
    { url: "un_enroll", component: <UnEnroll /> },
    { url: "notification", component: <Notification /> },
    { url: "new-users", component: <NewUsers /> },
    { url: "faqs", component: <FAQS /> },
    { url: "template", component: <Template /> },
    { url: ":id/sub-events/", component: <SubEvent /> },
    { url: "package", component: <Package /> },
    { url: ":id/tasks", component: <Taskss /> },
    { url: "guest-list", component: <GuestList /> },
    { url: "subscriptions", component: <Subscriptions /> },
    { url: "/user-details/:id/guest-list", component: <USER_GUESTS /> },
    { url: "/event_details/:id/tasks", component: <Event_tasks /> },
    { url: "/about-us", component: <AboutUs /> },
    { url: "/privacy-policy", component: <PrivacyPolicy /> },
    { url: "/partners", component: <Partners defaultTab="partners" /> },
    { url: "/partners-dashboard", component: <Partners defaultTab="dashboard" /> },
    { url: "/partners-billing", component: <Partners defaultTab="billing" /> },
    { url: "/partners-wedding", component: <Partners defaultTab="wedding" /> },
    { url: "/partners-host", component: <Partners defaultTab="hosts" /> },
    { url: "/photo-gallery/:id", component: <Photo_Gallery /> },
    { url: "/user-photo-gallery/:id", component: <USER_PHOTO /> },
    { url: "/edit-partner", component: <CreatePartner /> },
    { url: "/create-partner", component: <CreatePartner /> },
    { url: "/partner-detail/:id", component: <PartnerDetail /> },
    { url: "/partner-events/:id", component: <PartnerEvents /> },
    { url: "/refund-policy", component: <RefundAndCancellationPolicy /> },
    { url: "/delete-requests", component: <DeletePage /> },
    { url: "/plan-weddings/:id", component: <PlanWeddings /> },

    // { url: "/otp", component: <OtpLogin /> },
  ];

  return (
    <>
      <Routes>
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  //const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  return (
    <>
      <div id="main-wrapper" className={`show`}>
        {/* <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle": ""} ${ menuToggle ? "menu-toggle" : ""}`}>   */}
        <Nav />
        <div
          className="content-body"
          style={{ minHeight: window.screen.height - 45 }}
        >
          <div className="container-fluid bdy qx-main">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
function FrontLayout() {
  return (
    <>
      <div className="overflow-unset">
        {/* <Layout /> */}
        <Outlet />
      </div>
    </>
  );
}

export default Markup;
